import React, { useState, useEffect } from "react";
import { ChangeDateString,PassedMonths} from "../common/Common";

const ShowBigSizePhoto = ({varOpenBigPhoto,varChildrenData,CloseBigPhoto}) => {

  const [varPhoto,setPhoto] = useState(null);

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setPhoto(`${process.env.REACT_APP_HOST}/member/${varChildrenData.ch_file}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varOpenBigPhoto]);

  return (
    <div className={varOpenBigPhoto?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm" style={{height:"500px"}}>
        <div className="layer__bottom__head mb15">
          <div className="layer__pop__title" style={{paddingTop:"20px"}}>원생별 수강 현황</div>
          <div className="layer__pop__close" onClick={()=>CloseBigPhoto()}></div>
        </div>
        <div className="layer__pop__body" style={{marginTop:"10px"}}>  
          <div className="body-title" style={{textAlign:"center"}}> 
            <div className="children-info">
              {varChildrenData.ch_name} {PassedMonths(varChildrenData.ch_birthday)}개월({ChangeDateString(varChildrenData.ch_birthday)}) ({varChildrenData.ch_status===1?"재원":"퇴원"})
            </div>
          </div>
          <div className="body-payment" style={{marginTop:"10px"}}>
            <div className= "display-area">
              <div className="consbox2" style={{textAlign:"center"}} id="screens">
                <img className="shown-image" id="imgarea" style={{height:"380px"}} src={varPhoto} alt=""/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ShowBigSizePhoto;